import React from 'react'
import { createBrowserHistory } from 'history'
import { Router } from 'react-router-dom'
import { saveRefId, loadRefId, saveExtRefId, loadExtRefId } from './utils/storage'
import './i18n'
import { initialState, reducer } from './reducer/reducer'
import { StateProvider } from './StateProvider'
import { WhitelabelContainer } from './WhitelabelContainer'

const history = createBrowserHistory()
// Save referral ID for current user browser session
saveRefId(loadRefId())
saveExtRefId(loadExtRefId())

const App = () => {
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Router history={history}>
        <WhitelabelContainer />
      </Router>
    </StateProvider>)
}

export default App
